import { ArrowRight, Heart, Search } from "lucide-react";
import { Link } from "react-router-dom";
import { useCart } from "./cart";
import { ProductGrid } from "./components";
import { sp } from "./nav";
import { useWishlist } from "./wishlist";

export default function StoreSaved() {
  const { lang, st } = useCart();
  const { saved } = useWishlist();
  const es = lang === "es";
  return (
    <div data-testid="store-saved-page">
      <div className="flex flex-wrap items-center gap-4 rounded-2xl bg-[#0f2a3f] px-6 py-6 text-white sm:px-8">
        <span className="flex h-12 w-12 items-center justify-center rounded-full bg-white/10 text-rose-400"><Heart className="h-6 w-6" fill="currentColor" /></span>
        <div className="min-w-0 flex-1">
          <p className="text-xs font-bold uppercase tracking-[0.16em] text-emerald-400">Second Life · Appliance Parts</p>
          <h1 className="font-heading text-2xl font-bold sm:text-3xl">{es ? "Artículos guardados" : "Saved items"}</h1>
        </div>
        <span className="rounded-full bg-white/10 px-3 py-1 text-sm font-semibold text-slate-200" data-testid="store-saved-count">{saved.length} {es ? (saved.length === 1 ? "pieza" : "piezas") : (saved.length === 1 ? "part" : "parts")}</span>
      </div>
      {saved.length ? (
        <div className="mt-6"><ProductGrid items={saved} /></div>
      ) : (
        <div className="mx-auto mt-8 max-w-xl rounded-2xl border border-dashed border-slate-300 bg-white px-6 py-14 text-center" data-testid="store-saved-empty">
          <span className="mx-auto flex h-14 w-14 items-center justify-center rounded-full bg-slate-100 text-slate-400"><Heart className="h-7 w-7" /></span>
          <h2 className="mt-5 font-heading text-xl font-bold text-[#0f2a3f]">{es ? "Aún no guardaste artículos" : "You have no saved items yet"}</h2>
          <p className="mt-2 text-sm text-slate-500">{es ? "Toca el corazón en cualquier pieza para compararla cuando estés listo." : "Tap the heart on any part to compare it when you are ready."}</p>
          <div className="mt-6 flex flex-wrap items-center justify-center gap-3">
            <Link data-testid="store-saved-newest-link" to={sp("/search?sort=newest")} className="inline-flex items-center gap-2 rounded-full bg-[#0f2a3f] px-5 py-2.5 text-sm font-semibold text-white transition-colors hover:bg-emerald-700">{st("newest_parts")}<ArrowRight className="h-4 w-4" /></Link>
            <Link data-testid="store-saved-browse-link" to={sp("/search")} className="inline-flex items-center gap-2 rounded-full border border-slate-300 bg-white px-5 py-2.5 text-sm font-semibold text-slate-700 transition-colors hover:border-emerald-600 hover:text-emerald-700"><Search className="h-4 w-4" />{es ? "Explorar piezas" : "Browse parts"}</Link>
          </div>
        </div>
      )}
    </div>
  );
}
